export const SERVICE = "admin/service";
export const FAQ = "admin/faq";
export const LEGAL = "admin/legal-info";
export const RESOURCES = "admin/resources";
export const FILEUPLAOD = "user/auth/upload";
export const FILEURL = "user/auth/getPreAssignUrl";
export const ADDEDUCATION = "admin/education";
export const PRIVACYPOLICY = "admin/privacy";
export const TERMSCONDITIONS = "admin/getTermsAndCondition";
export const UPDATE_TERMSCONDITIONS = "admin/setTermsAndCondition";
export const ABOUT = "/admin/getAboutUsPage"
export const UPDATE_ABOUT="/admin/setAboutUsPage"
export const PROMOTION = "admin/promotion";
export const SEARCH = "admin/createCategory";
export const CASEREFERAL = "admin/case-referral";
export const APPOINTMENTSREFERAL = "admin/appointment";
export const DASHBOARDS_STATS = "/admin/dashboard";
export const DASHBOARDS_PEAK = "admin/appointment/reports/peak-periods";
export const SUBADMIN = "admin/usersList";
export const VENDOR = "admin/getSaveVendors";
export const DELETE = "admin/deleteUser"
export const DELETE_AD = "/admin/deleteAd"
export const CATEOGRY = "admin"
export const VENDORREQUEST="admin/approveVendor"
export const VERIFYUSER="admin/verifyUser"
export const EDITVENDORCATEGORY="admin/editVendorCategory"
export const USER_CHATS="chat/usersConversations"
export const INDIVIDUAL_CHAT= "chat/chatAdmin"
export const PRIVACY_POLICY="admin/getPrivacyPolicy"
export const UPDATE_POLICY="admin/setPrivacyPolicy"
export const GET_CONTRACTS="admin/getContracts"
export const FLAT_DETAIL="/admin/adDetail"


